import React from 'react'
import { useTranslation } from 'react-i18next'
import { EventType } from 'types/NewsItem'

function NewsHeadlineProspectusMemorandum({ row }: { row: { companyName: string; eventType: EventType } }) {
    const { t } = useTranslation()
    const { companyName, eventType } = row

    const documentType =
        eventType === 'prospectus'
            ? t('pages.news.headlines.prospectus.prospectus')
            : eventType === 'informationdocument'
              ? t('pages.news.headlines.prospectus.informationDocument')
              : eventType

    return (
        <span>
            {t('pages.news.headlines.prospectus.document', {
                companyName,
                documentType,
            })}
        </span>
    )
}

export default NewsHeadlineProspectusMemorandum
